import { displayError, getApiUrl, getCurrentLanguageId, addEventListenerIfNotExists } from "./common";
import HttpClient from "./http-client";
import LoadingIndication from "./loading-indication";

export default class PayUPayment {
    private baseElement: HTMLElement;
    private buttonElement: HTMLElement;
    private orderGuid: string;

    private static _componentName = 'PayUPayment';
    private static buttonName = 'payu-proceed-button';

    static get componentName() {
        return PayUPayment._componentName;
    }

    constructor() {
        this.baseElement = document.querySelector(`[data-component="${PayUPayment.componentName}"]`);
        this.orderGuid = this.baseElement.dataset.orderGuid;
        this.buttonElement = this.baseElement.querySelector(`[data-component-part="${PayUPayment.buttonName}"]`);
        addEventListenerIfNotExists(this.buttonElement, 'click', (evt) => this.procceed(evt));
    }

    private async procceed(evt: Event): Promise<void> {
        evt.preventDefault();
        this.startLoading();
        await this.createPayment();

    }

    private async createPayment() {

        const url = `${getApiUrl()}/PayUPayment/create-payment`;

        const response = await new HttpClient().fetch(url, {
            method: 'POST',
            body: JSON.stringify({
                orderGuid: this.orderGuid,
                returnUrl: window.location.href
            }),
            headers: {
                'Content-Type': 'application/json',
                'Current-Language-Id': getCurrentLanguageId()
            }
        }, (e) => {
            this.stopLoading();
            displayError("Payment creation failed. " + e);
            return null;
        });

        if (!response.ok) {
            this.stopLoading();
            displayError("Payment creation failed.");
            return null;
        }

        var json: string = await response.json();
        json = json.replace(/['"]+/g, '');
        window.location.replace(json);

    }

    private startLoading() {
        LoadingIndication.show(this.baseElement);
    }

    private stopLoading() {
        LoadingIndication.hide(this.baseElement);
    }
}
